// src/components/messages/AttachmentCard.js
import React, { useState } from 'react';
import { messagingService } from '../../services/messagingService';
import MaterialIcon from '../ui/MaterialIcon';
import { openDocumentUrlNatively } from '../../utils/mobileDocumentOpen';

function getIcon(mimeType) {
  if (mimeType.startsWith('image/')) return 'image';
  if (mimeType === 'application/pdf') return 'picture_as_pdf';
  return 'draft';
}

function formatBytes(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

const AttachmentCard = ({ attachment }) => {
  const [downloading, setDownloading] = useState(false);
  const iconName = getIcon(attachment.mime_type || '');

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const url = await messagingService.getSignedUrl(attachment.storage_path);
      openDocumentUrlNatively(url, attachment.filename);
    } catch (err) {
      console.error('Download failed:', err);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <button
      onClick={handleDownload}
      disabled={downloading}
      className="min-h-[56px] flex items-center gap-3 px-3 py-2 rounded-2xl border border-amber-100/40 bg-section-bg hover:bg-white transition-colors text-left w-full max-w-xs"
    >
      <div className="w-10 h-10 rounded-xl bg-white border border-amber-100/40 flex items-center justify-center flex-shrink-0">
        {downloading
          ? <MaterialIcon name="progress_activity" size={20} className="text-secondary animate-spin" />
          : <MaterialIcon name={iconName} size={20} className="text-secondary" />
        }
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium text-slate-800 truncate">{attachment.filename}</p>
        <p className="text-xs text-slate-400">{formatBytes(attachment.size_bytes)}</p>
      </div>
      <MaterialIcon name="open_in_new" size={18} className="text-slate-400 flex-shrink-0" />
    </button>
  );
};

export default AttachmentCard;
